(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["topbar-countdown-ie"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ZONE = 'Europe/Dublin';
  var DAY = 86400;
  var fmt = null;

  try {
    fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: ZONE,
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } catch (e) {
    fmt = null;
  }

  function secondsLeft() {
    var h, m, s;

    if (fmt) {
      var parts = fmt.formatToParts(new Date());
      var got = {};
      for (var i = 0; i < parts.length; i++) {
        got[parts[i].type] = parts[i].value;
      }
      h = parseInt(got.hour, 10);
      m = parseInt(got.minute, 10);
      s = parseInt(got.second, 10);
      if (h === 24) { h = 0; }
    } else {
      var now = new Date();
      h = now.getUTCHours();
      m = now.getUTCMinutes();
      s = now.getUTCSeconds();
    }

    var left = DAY - (h * 3600 + m * 60 + s);
    return left <= 0 ? DAY : left;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function render(nodes) {
    var t = secondsLeft();
    var text =
      pad(Math.floor(t / 3600)) + ' : ' +
      pad(Math.floor((t % 3600) / 60)) + ' : ' +
      pad(t % 60);

    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = text;
    }
  }

  function start() {
    var nodes = document.querySelectorAll('[data-tbc] [data-tbc-digits]');
    if (!nodes.length) { return; }

    render(nodes);
    setInterval(function () { render(nodes); }, 1000);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { render(nodes); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var vids = document.querySelectorAll('[data-vt] video');
    if (!vids.length) { return; }

    for (var i = 0; i < vids.length; i++) {
      vids[i].addEventListener('play', function () {
        for (var j = 0; j < vids.length; j++) {
          if (vids[j] !== this) { vids[j].pause(); }
        }
      });
    }

    if (!('IntersectionObserver' in window)) { return; }

    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (!entries[k].isIntersecting) {
          var v = entries[k].target;
          if (!v.paused) { v.pause(); }
        }
      }
    }, { threshold: 0.25 });

    for (var m = 0; m < vids.length; m++) { io.observe(vids[m]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
